import type {PayloadAction} from '@reduxjs/toolkit';

import {createSlice} from '@reduxjs/toolkit';

import {
  builderGetCaptcha,
  builderLoginByOtp,
  builderLoginByUserAndPass,
  builderSendOtp
} from './reducer';

const initialState: any = {
  auth: undefined,
  logging: false,
  loginError: '',
  sendingOtp: false,
  sendOtpError: '',
  captchaLoading: false,
  captcha: null,
  captchaToken: null
};

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    resetUser: (state: any) => {
      state.user = undefined;
    },
    setCaptchaToken: (state: any, action: PayloadAction<string>) => {
      state.captchaToken = action.payload;
    },
    resetAuth: (state: any) => {
      state.auth = undefined;
    }
  },
  extraReducers: (builder) => {
    //login by user and password
    builderLoginByUserAndPass(builder);

    //login by Otp
    builderLoginByOtp(builder);

    //send otp
    builderSendOtp(builder);

    builderGetCaptcha(builder);
  }
});

export const {resetAuth, resetUser, setCaptchaToken} = loginSlice.actions;
export default loginSlice.reducer;
